/**
 * sort-members.js
 */


const sortMembers = (user) => (a, b) => {
  // sort by creator, then me, then name alphabetically
  // if (a.id === creator.id) return -1;
  // if (b.id === creator.id) return 1;
  if (a.id === user.id) return -1;
  if (b.id === user.id) return 1;
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  return 0;
}

export default sortMembers;